import React, { useState, useEffect } from 'react';
import moment from 'moment';

export default (props: {
  end_at: string;
  onTick?: () => void;
  onStop?: () => void;
  duration?: number;
}) => {
  const { end_at, onTick, onStop, duration = 1000 } = props;
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    let timer = 0;

    const onTimer = () => {
      let now = moment().valueOf();
      if (onTick) {
        onTick();
      }
      if (now >= moment(end_at).valueOf()) {
        if (onStop) {
          onStop();
        }
      } else {
        setCurrent(now);
      }
    };

    timer = window.setTimeout(onTimer, duration);

    return () => {
      window.clearTimeout(timer);
    };
  }, [current, end_at]);

  return <React.Fragment></React.Fragment>;
};
